import { render, staticRenderFns } from "./0to10.vue?vue&type=template&id=7a9424ba"
import script from "./0to10.vue?vue&type=script&lang=js"
export * from "./0to10.vue?vue&type=script&lang=js"
import style0 from "./0to10.vue?vue&type=style&index=0&id=7a9424ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports